import {
  Box,
  Button,
  Checkbox,
  CloseButton,
  Dialog,
  Heading,
  HStack,
  Portal,
  Separator,
  Switch,
  Text,
  VStack,
} from "@chakra-ui/react";
import { Settings } from "lucide-react";
import { useState } from "react";
import { useMerchant } from "../../../../hooks/useMerchant";

export const RulesStatementButton = () => {
  const { merchant } = useMerchant();
  const [open, setOpen] = useState(false);

  const sendRuleLabels = {
    creation: "Siguiente ciclo después de creación del recaudo",
    dueDate: "Día hábil antes de la fecha de vencimiento",
    expirationDate: "Día hábil antes de última fecha de pago",
    deadlines: "Día hábil antes de cada fecha de corte",
    startOfMonth: "Primer día hábil del mes",
  };

  return (
    <>
      <Button onClick={() => setOpen(true)} size="sm">
        <Settings size={16} />
        Configuración de Whatsapp
      </Button>

      <Dialog.Root
        open={open}
        onOpenChange={(e) => setOpen(e.open)}
        size="lg"
        placement="center"
      >
        <Portal>
          <Dialog.Backdrop />
          <Dialog.Positioner>
            <Dialog.Content>
              <Dialog.Header borderBottom="1px solid #ebecef80" padding="4">
                <Dialog.Title>
                  <Heading fontWeight={600} fontSize={"1.375rem"}>
                    Configuración de WhatsApp
                  </Heading>
                </Dialog.Title>
              </Dialog.Header>
              <Dialog.CloseTrigger asChild>
                <CloseButton marginTop="1" onClick={() => setOpen(false)} />
              </Dialog.CloseTrigger>

              <Dialog.Body py={6}>
                <VStack align="stretch" gap={6}>
                  <Box>
                    <Text fontSize={"1rem"} color={"#9F9DB0"}>
                      Consulta las reglas de automatización en Whatsapp.
                    </Text>
                  </Box>

                  <VStack align="stretch" gap={3}>
                    <Box>
                      <Text fontWeight={600} fontSize={"1.125rem"} mb={3}>
                        Estado
                      </Text>
                      <HStack align="center">
                        <Switch.Root
                          checked={merchant?.whatsappConfig?.active || false}
                          disabled
                          size="md"
                        >
                          <Switch.Control>
                            <Switch.Thumb />
                          </Switch.Control>
                        </Switch.Root>
                        <Text>
                          {merchant?.whatsappConfig?.active
                            ? "Envíos activos"
                            : "Envíos inactivos"}
                        </Text>
                      </HStack>
                    </Box>

                    <Separator />

                    <Box>
                      <Text fontWeight={600} fontSize={"1.125rem"} mb={3}>
                        Reglas de envío
                      </Text>
                      <VStack align="stretch" gap={2}>
                        {Object.entries(sendRuleLabels).map(([key, label]) => (
                          <Checkbox.Root
                            key={key}
                            checked={
                              merchant?.whatsappConfig.sendRules[
                                key as keyof typeof sendRuleLabels
                              ] || false
                            }
                            disabled
                            size="md"
                          >
                            <Checkbox.HiddenInput />
                            <Checkbox.Control>
                              <Checkbox.Indicator />
                            </Checkbox.Control>
                            <Checkbox.Label>{label}</Checkbox.Label>
                          </Checkbox.Root>
                        ))}
                      </VStack>
                    </Box>
                  </VStack>

                  <Box>
                    <Text fontSize={"1rem"} color={"#9F9DB0"} mt={2}>
                      Por el momento, no puedes configurar tus recordatorios de
                      Whatsapp directamente. Si deseas hacer cambios, por favor
                      envíanos un mensaje y nos encargaremos de ello.
                    </Text>
                  </Box>
                </VStack>
              </Dialog.Body>
            </Dialog.Content>
          </Dialog.Positioner>
        </Portal>
      </Dialog.Root>
    </>
  );
};
